export { default } from './beauty-brands.component';
